module.exports = __webpack_public_path__ + "static/media/hidrogeno verde usos motrices.09e7978e.jpg";